module.exports = __webpack_public_path__ + "img/export8.a0e3d186.png";